import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { User } from '../models/user';

export const mspRouteGuard: CanActivateFn = (route, state) => {
  let router = inject(Router);
  let user = inject(User);

  if (!user.access_token) {
    return router.createUrlTree(['/auth/login'], { queryParams: { redirectUrl: state.url } });
  }

  // Check if the user is an admin
  if (user.groups.includes('admin')) {
    return true; // Allow unrestricted access for admins
  }

  // Check if the user has MSP access
  // if (!user.groups.includes('msp')) {
  //   return router.createUrlTree(['customer/unauthorized']);
  // }

  // Check if this is the partner-analytics route
  if (state.url.includes('/msp-portal/partner-analytics')) {
    if (user.primary_organization?.account_type !== 2 && user.primary_organization?.account_type !== 3) {
      return router.createUrlTree(['customer/unauthorized']);
    }
  }

  return true;
};
